import * as Bixby from './../../core';
import { StaticDataItemDataState, StaticDataActionTypes } from './types';
import { ThunkAction } from 'redux-thunk';
import { Reducer } from 'redux';

export default function create<T, TLoading extends string, TSuccess extends string, TFailure extends string>(
  load: () => Promise<T[]>,
  loadingType: TLoading,
  successType: TSuccess,
  failureType: TFailure
) {
  // action creators
  const loadAction = () => {
    return {
      type: loadingType,
    };
  };

  const successAction = (items: T[]) => {
    return {
      type: successType,
      payload: items,
    };
  };

  const failureAction = (error: Bixby.Models.BixbyError) => {
    return {
      type: failureType,
      payload: error,
      error: true,
    };
  };

  // thunk actions
  const get = (): ThunkAction<Promise<void>, object, null, Bixby.Models.BixbyAction> => async dispatch => {
    dispatch(loadAction());

    try {
      const items = await load();
      dispatch(successAction(items));
    } catch (error: any) {
      dispatch(failureAction(error));
    }
  };

  const initialState: StaticDataItemDataState<T> = {
    isLoading: false,
  };

  const reducer: Reducer<StaticDataItemDataState<T>> = (
    state = initialState,
    action: StaticDataActionTypes<T, TLoading, TSuccess, TFailure>
  ): StaticDataItemDataState<T> => {
    switch (action.type) {
      case loadingType:
        return {
          ...state,
          isLoading: true,
          loadingError: undefined,
        };
      case successType:
        const payload: T[] = action.payload || [];
        return {
          ...state,
          isLoading: false,
          data: payload,
          loadingError: undefined,
        };
      case failureType:
        return {
          ...state,
          isLoading: false,
          loadingError: action.payload as Bixby.Models.BixbyError,
        };
      default:
        return state;
    }
  };

  return {
    get,
    reducer,
  };
}
